(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-slider"] && !window.DesignMode) return;
  try {
    
Vue.use(VueAwesomeSwiper)

new Vue({
  el: '#swiperComponentCollection',
  data: {
    swiperOptions: {
      preloadImages: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: false, 
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    }
  },
  computed: {
    swiperComponentCollection() {
        return this.$refs.swiperComponentCollection.$swiper; 
    }
  },
  methods: {
    onResize() {
      if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
        this.swiperComponentCollection.$wrapperEl[0].style.display = 'none';
      } else {
        this.swiperComponentCollection.$wrapperEl[0].style.display = ''; 
      } 
    },
    onSwiperClickSlide(props) {
      window.location = this.swiperComponentCollection.clickedSlide.dataset.linkTo;
    }
  },
  mounted() {
    if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
      this.swiperComponentCollection.$wrapperEl[0].style.display = 'none';
    }
  } 
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["damen-logo-swiper"] && !window.DesignMode) return;
  try {
    
Vue.use(VueAwesomeSwiper)

new Vue({
  el: '#swiperComponent',
  data: {
    swiperOptions: {
      preloadImages: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: false, 
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        568: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        768: {
          slidesPerView: 7,
          slidesPerGroup: 7, 
        },
      }
    }
  },
  computed: {
    swiperComponent() {
        return this.$refs.swiperComponent.$swiper; 
    }
  },
  methods: {
    onResize() {
      if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
        this.swiperComponent.$wrapperEl[0].style.display = 'none';
      } else {
        this.swiperComponent.$wrapperEl[0].style.display = ''; 
      } 
    },
    onSwiperClickSlide(props) {
      window.location = this.swiperComponent.clickedSlide.dataset.linkTo;
    }
  },
  mounted() {
    if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
      this.swiperComponent.$wrapperEl[0].style.display = 'none';
    }
  } 
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herren-logo-swiper"] && !window.DesignMode) return;
  try {
    
Vue.use(VueAwesomeSwiper)

new Vue({
  el: '#swiperComponent',
  data: {
    swiperOptions: {
      preloadImages: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: false, 
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        568: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        768: {
          slidesPerView: 7,
          slidesPerGroup: 7, 
        },
      }
    }
  },
  computed: {
    swiperComponent() {
        return this.$refs.swiperComponent.$swiper; 
    }
  },
  methods: {
    onResize() {
      if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
        this.swiperComponent.$wrapperEl[0].style.display = 'none';
      } else {
        this.swiperComponent.$wrapperEl[0].style.display = ''; 
      } 
    },
    onSwiperClickSlide(props) {
      window.location = this.swiperComponent.clickedSlide.dataset.linkTo;
    }
  },
  mounted() {
    if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
      this.swiperComponent.$wrapperEl[0].style.display = 'none';
    }
  } 
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper"] && !window.DesignMode) return;
  try {
    
Vue.use(VueAwesomeSwiper)

new Vue({
  el: '#swiperComponent',
  data: {
    swiperOptions: {
      preloadImages: true,
      slidesPerView: 1,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: false, 
      spaceBetween: 0,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        568: {
          slidesPerView: 4,
          slidesPerGroup: 4,
        },
        768: {
          slidesPerView: 7,
          slidesPerGroup: 7, 
        },
      }
    }
  },
  computed: {
    swiperComponent() {
        return this.$refs.swiperComponent.$swiper; 
    }
  },
  methods: {
    onResize() {
      if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
        this.swiperComponent.$wrapperEl[0].style.display = 'none';
      } else {
        this.swiperComponent.$wrapperEl[0].style.display = ''; 
      } 
    },
    onSwiperClickSlide(props) {
      window.location = this.swiperComponent.clickedSlide.dataset.linkTo;
    }
  },
  mounted() {
    if ( window.matchMedia( '(max-width: 568px)' ).matches ) {
      this.swiperComponent.$wrapperEl[0].style.display = 'none';
    }
  } 
})

  } catch(e) { console.error(e); }
})();

})();
